import { Component } from "@angular/core";

// Component is used so that the SVG can embed CSS color variables
@Component({
  selector: "app-image-org-subscription-hidden",
  templateUrl: "image-subscription-hidden.component.svg",
})
export class ImageSubscriptionHiddenComponent {}
